import React from 'react';
import { Layout, Row, Col, Typography } from 'antd';
import { EnvironmentOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const { Footer } = Layout;
const { Title, Text, Link } = Typography;

const AppFooter = () => {
  const { t } = useTranslation();
  
  return (
    <Footer style={{ 
      background: '#001529', 
      padding: '48px 24px 24px',
      flexShrink: 0,
      width: '100%'
    }}>
      <Row gutter={[48, 32]}>
        <Col xs={24} sm={12} md={12}>
          <Title level={4} style={{ color: 'white' }}>{t('footer.title')}</Title>
          <Text style={{ color: 'rgba(255,255,255,0.8)', display: 'block', marginBottom: '16px' }}>
            <EnvironmentOutlined style={{ marginRight: '8px' }} />
            {t('footer.address')}
          </Text>
        </Col>

        <Col xs={24} sm={12} md={12}>
          <Title level={5} style={{ color: 'white' }}>{t('footer.bookNow')}</Title>
          <ul style={{ listStyle: 'none', padding: 0 }}>
            <li style={{ margin: '8px 0' }}>
              <Link href="https://airbnb.com/h/cadecampo" target="_blank" style={{ color: 'rgba(255,255,255,0.8)' }}>
                {t('footer.airbnb')}
              </Link>
            </li>
          </ul>
        </Col>
      </Row>
    </Footer>
  );
};

export default AppFooter;
